import remarkGfm from 'remark-gfm';
import remarkParse from 'remark-parse';
import remarkStringify from 'remark-stringify';
import { unified } from 'unified';
/**
 * Очищает markdown от неподдерживаемых конструкций, оставляя только CommonMark/GFM.
 */
export function cleanMarkdown(text) {
    if (!text)
        return '';
    const file = unified().use(remarkParse).use(remarkGfm).use(remarkStringify).processSync(text);
    return String(file);
}
/**
 * Функция для обработки массива строк, добавляющая пустые строки после таблиц.
 */
export const processDesc = (desc) => {
    if (!desc)
        return '–';
    const processed = [];
    for (let i = 0; i < desc.length; i++) {
        processed.push(desc[i]);
        if (desc[i].trim().startsWith('|') &&
            i + 1 < desc.length &&
            !desc[i + 1].trim().startsWith('|')) {
            processed.push('');
        }
    }
    return processed.join('\n');
};
